/**
 * 2FA otomatik gönderim kuralı.
 *
 * Altı hane tamamlandığında form bir kez gönderilmelidir. `busy` false'a
 * döndüğünde aynı kod yeniden denenirse hatalı kod **sonsuz istek döngüsü**
 * üretir. Son denenen kod saklanır; aynı değer ikinci kez otomatik gönderilmez.
 */
export interface AutoSubmitTwoFactorInput {
  isTwoFactorStep: boolean;
  code: string;
  busy: boolean;
  lastAttemptedCode: string | null;
}

export function shouldAutoSubmitTwoFactor(input: AutoSubmitTwoFactorInput): boolean {
  const code = input.code.trim();
  return (
    input.isTwoFactorStep && !input.busy && code.length === 6 && code !== input.lastAttemptedCode
  );
}
